import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, CardBody, Button, Badge, Alert } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { useNavigate, useParams } from 'react-router-dom'
import { getIdData } from '../../lib/instructorinfo'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { InstructorScheduleDays } from './InstructorScheduleDays'

const AdminInstructorDetail = () => {
	const [instructorInfo, setInstructorInfo] = useState(null)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState('')

	const navigate = useNavigate()
	const { id } = useParams()
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const fetchInstructorData = async () => {
		try {
			setLoading(true)
			const info = await getIdData(id)
			setInstructorInfo(info)
		} catch (error) {
			console.error('Error fetching instructor data:', error)
			setError('Failed to load instructor information')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchInstructorData()
	}, [id])

	if (loading) {
		return (
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardBody className="text-center">
								<div className="spinner-border" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
								<p className="mt-2">Loading instructor information...</p>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		)
	}

	if (error || !instructorInfo || !instructorInfo[0]) {
		return (
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardBody className="text-center">
								<Alert color="danger">{error || 'Instructor not found'}</Alert>
								<Button color="primary" onClick={() => navigate(-1)}>
									Go Back
								</Button>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		)
	}

	const instructor = instructorInfo[0]

	return (
		<>
			<Breadcrumbs parent="Instructor Management" title="Instructor Details" mainTitle="Instructor Information" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Instructor Details" subTitle="View instructor information" />
							<CardBody>
								<Row>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">First Name</label>
											<p className="mb-0">{instructor.name || 'N/A'}</p>
										</div>
									</Col>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">Last Name</label>
											<p className="mb-0">{instructor.surname || 'N/A'}</p>
										</div>
									</Col>
								</Row>

								<Row>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">Phone</label>
											<p className="mb-0">{instructor.phone || 'N/A'}</p>
										</div>
									</Col>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">Email</label>
											<p className="mb-0">{instructor.email || 'N/A'}</p>
										</div>
									</Col>
								</Row>

								<Row>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">Username</label>
											<p className="mb-0">{instructor.username || 'N/A'}</p>
										</div>
									</Col>
									<Col lg="6">
										<div className="form-group mb-3">
											<label className="form-control-label fw-bold">Status</label>
											<p className="mb-0">
												<Badge color={instructor.isActive ? 'success' : 'secondary'} className="px-2 py-1">
													{instructor.isActive ? 'Active' : 'Inactive'}
												</Badge>
											</p>
										</div>
									</Col>
								</Row>

								<div className="d-flex justify-content-between mt-4">
									<Button color="primary" onClick={() => navigate(`${process.env.PUBLIC_URL}/${role}/instructors/edit/${id}/Update/${layout}`)}>
										Update Profile
									</Button>
									<Button color="secondary" onClick={() => navigate(-1)}>
										Go Back
									</Button>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>

				{/* Instructor Schedule Section */}
				<Row>
					<Col sm="12">
						<InstructorScheduleDays slug={id} />
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminInstructorDetail }
